import React from 'react';
import styled from 'styled-components';

const ConstantlyMovingBar = styled.div`
    @keyframes constantlyMovingBarAnimation {
        to {
            transform: translate(800px, 0);
        }
    }
    position: absolute;
    background: tomato;
    height: 10px;
    left: 0;
    width: 100px;
    bottom: 0;
    z-index: 30;
    animation-duration: ${800 / 60 * 1000}ms;
    animation-name: constantlyMovingBarAnimation;
    animation-iteration-count: infinite;
    animation-timing-function: linear;
`;

const ConstantlyMovingBarWrapper = styled.div`
    height: 10px;
    position: relative;
`;

const MovingBar = ({ screencast }) => {
    if (!screencast) return null;
    return (
        <ConstantlyMovingBarWrapper>
            <ConstantlyMovingBar />
        </ConstantlyMovingBarWrapper>
    );
};

export default MovingBar;



/** WEBPACK FOOTER **
 ** ../src/widgets/components/sm/animated/views/ConstantlyMovingBar.js
 **/